import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { importProvidersFrom } from '@angular/core';
import { OktaAuthModule } from '@okta/okta-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MessageService } from 'primeng/api';

import { routes } from './app.routes';
import { provideAuth } from './core/auth/providers/auth.providers';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    // Auth providers
    ...provideAuth(),
    // PrimeNG MessageService for global toast notifications
    MessageService,
    // Import providers from modules that don't have standalone providers yet
    importProvidersFrom(
      OktaAuthModule,
      NgxSpinnerModule
    ),
    // Add other providers as needed
  ]
};
